import { _t } from "content";

interface PrevArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  classArrow?: string;
}

export function PrevArrow({ className, onClick, style, classArrow, onMouseEnter, onMouseLeave }: PrevArrowProps) {
  return (
    <div style={style} className={className} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <svg
        className={classArrow ? classArrow : "prev-arrow-home"}
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="70"
        viewBox="0 0 63.88 103.804"
        fill={_t.color1}
      >
        <g
          id="Grupo_480"
          data-name="Grupo 480"
          transform="translate(2468.793 1289.763) rotate(45)"
        >
          <rect
            id="Retângulo_1560"
            data-name="Retângulo 1560"
            width="16.939"
            height="73.401"
            rx="8.469"
            transform="translate(-2621 797)"
          />
          <rect
            id="Retângulo_1561"
            data-name="Retângulo 1561"
            width="73.401"
            height="16.939"
            rx="8.469"
            transform="translate(-2621 853.462)"
          />
        </g>
      </svg>
    </div>
  );
}
